/**
 * 인증 API 서비스 (학생용)
 * - 로그인
 * - 사용자 정보 조회
 * - 로그아웃
 */

import axios from '../config/axios';
import { LoginRequest, AuthResponse } from '../types/auth';
import { Student } from '../types/user';

/**
 * 인증 서비스 클래스
 */
class AuthService {
  /**
   * 로그인
   * - OAuth2PasswordRequestForm 형식으로 전송
   * @param credentials - 이메일, 비밀번호
   * @returns JWT 토큰
   */
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    // OAuth2 Form 데이터 생성
    const formData = new FormData();
    formData.append('username', credentials.email); // OAuth2는 username 필드 사용
    formData.append('password', credentials.password);

    const response = await axios.post<AuthResponse>('/auth/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  }

  /**
   * 현재 로그인한 사용자 정보 조회
   * @returns 학생 정보
   */
  async getCurrentUser(): Promise<Student> {
    const response = await axios.get<Student>('/auth/me');
    return response.data;
  }

  /**
   * 로그아웃
   * - 클라이언트 사이드에서 토큰 삭제로 처리
   */
  async logout(): Promise<void> {
    try {
      // 백엔드에 로그아웃 API가 있다면 호출
      // await axios.post('/auth/logout');
    } catch (error) {
      console.error('Logout API error:', error);
    }
  }
}

export const authService = new AuthService();
